// extracted by mini-css-extract-plugin
export default {"row":"UnsavedChangesNotice_row__KYLoL","notice":"UnsavedChangesNotice_notice__Ctd3R"};